import { useQuery } from '@tanstack/react-query'
import { api } from './api'

export type PartnerAccessStatus = 'pending' | 'active' | 'suspended'

// Pre-onboarding gate state. Returned by GET /partners/access, which — unlike
// GET /partners/me — resolves even before a Partner profile exists, so it can
// drive the verification screen that sits ahead of profile creation.
export type PartnerAccess = {
  status: PartnerAccessStatus
  hasPartner: boolean
  // Applicant's name, collected on the verification screen. null until supplied.
  name: string | null
}

export function useAccess(enabled: boolean) {
  return useQuery<PartnerAccess>({
    queryKey: ['me', 'access'],
    enabled,
    queryFn: () => api.get<PartnerAccess>('/partners/access'),
  })
}
